(function () {

function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global =
        typeof globalThis !== 'undefined'
          ? globalThis
          : typeof self !== 'undefined'
          ? self
          : typeof window !== 'undefined'
          ? window
          : typeof global !== 'undefined'
          ? global
          : {};
  
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequired124"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequired124"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
parcelRegister("h9OH6", function(module, exports) {

$parcel$export(module.exports, "_type_of", function () { return $c7da99bc8f965133$export$5f0017c582d45a2d; });
$parcel$export(module.exports, "_", function () { return $c7da99bc8f965133$export$5f0017c582d45a2d; });
function $c7da99bc8f965133$export$5f0017c582d45a2d(obj) {
    "@swc/helpers - typeof";
    return obj && typeof Symbol !== "undefined" && obj.constructor === Symbol ? "symbol" : typeof obj;
}

});

parcelRegister("70P4J", function(module, exports) {
/**
 * Create a dom element
 * @param  string elementType Required - The type of element to create
 * @param  object attributes  Optional - A list of attribute to add to the element
 * @param  string textNode    Optional - Any text to add to the element
 * @return object Element
 */ 
var $haqKc = parcelRequire("haqKc");
module.exports = function(elementType, attributes, textNode) {
    var element = document.createElement(elementType);
    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
    try {
        //
        for(var _iterator = Object.entries(attributes || {})[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
            var _step_value = (0, $haqKc._)(_step.value, 2), attributeName = _step_value[0], attributeValue = _step_value[1];
            if (attributeName in element) element[attributeName] = attributeValue;
            else element.setAttribute(attributeName, attributeValue);
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion && _iterator.return != null) {
                _iterator.return();
            }
        } finally{
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }
    //
    if (typeof textNode !== "undefined") element.append(document.createTextNode(textNode));
    //
    return element;
};

});
parcelRegister("haqKc", function(module, exports) {

$parcel$export(module.exports, "_", function () { return $c7f81dae783d026c$export$fdf2a89c76341bbf; });

var $kAoWz = parcelRequire("kAoWz");

var $51zgv = parcelRequire("51zgv");

var $8w5yq = parcelRequire("8w5yq");

var $8YVFh = parcelRequire("8YVFh");
function $c7f81dae783d026c$export$fdf2a89c76341bbf(arr, i) {
    return (0, $kAoWz._array_with_holes)(arr) || (0, $51zgv._iterable_to_array_limit)(arr, i) || (0, $8YVFh._unsupported_iterable_to_array)(arr, i) || (0, $8w5yq._non_iterable_rest)();
}

});
parcelRegister("kAoWz", function(module, exports) {

$parcel$export(module.exports, "_array_with_holes", function () { return $efca84b713134a66$export$e6256bf45c68d561; });
function $efca84b713134a66$export$e6256bf45c68d561(arr) {
    if (Array.isArray(arr)) return arr;
}

});

parcelRegister("51zgv", function(module, exports) {

$parcel$export(module.exports, "_iterable_to_array_limit", function () { return $3a8866aa092b1ebb$export$2fd15edff6687200; });
function $3a8866aa092b1ebb$export$2fd15edff6687200(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}

});

parcelRegister("8w5yq", function(module, exports) {

$parcel$export(module.exports, "_non_iterable_rest", function () { return $63359ed8917f3ec8$export$60dbc22abd7da546; });
function $63359ed8917f3ec8$export$60dbc22abd7da546() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}

});

parcelRegister("8YVFh", function(module, exports) {

$parcel$export(module.exports, "_unsupported_iterable_to_array", function () { return $68a0a85bb5bfa568$export$a5be06335b3a083c; });

var $822BU = parcelRequire("822BU");
function $68a0a85bb5bfa568$export$a5be06335b3a083c(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return (0, $822BU._array_like_to_array)(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return (0, $822BU._array_like_to_array)(o, minLen);
}

});
parcelRegister("822BU", function(module, exports) {

$parcel$export(module.exports, "_array_like_to_array", function () { return $5d9088fdefde415d$export$79e617b1955a2616; });
function $5d9088fdefde415d$export$79e617b1955a2616(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}

});




//

var $h9OH6 = parcelRequire("h9OH6");

var $70P4J = parcelRequire("70P4J");
//
$ba66290d7469d0f5$var$addActionToRemoveButtons();
$ba66290d7469d0f5$var$calculateTotalFee();
//add new address
var $ba66290d7469d0f5$var$template = document.querySelector('script[id="tpl-address"]');
if ($ba66290d7469d0f5$var$template) {
    //
    var $ba66290d7469d0f5$var$addressWrapper = document.querySelector('[data-name="tenants-addresses"]');
    //
    var $ba66290d7469d0f5$var$addButtonWrapper = document.querySelector('[data-name="add-address-button-wrapper"]');
    var $ba66290d7469d0f5$var$addAddressButton = document.querySelector('button[data-action="add-address"]');
    //
    if ($ba66290d7469d0f5$var$addressWrapper !== null && $ba66290d7469d0f5$var$addButtonWrapper !== null && $ba66290d7469d0f5$var$addAddressButton !== null) $ba66290d7469d0f5$var$addAddressButton.addEventListener("click", function(event) {
        //
        var index = document.querySelectorAll('div[data-name="address"]').length;
        //
        var address = $70P4J("div", {
            "data-name": "address",
            "data-id": index
        });
        //
        address.innerHTML = $ba66290d7469d0f5$var$template.innerHTML;
        //
        $ba66290d7469d0f5$var$addressWrapper.append(address);
        //
        $ba66290d7469d0f5$var$addActionToRemoveButtons();
        $ba66290d7469d0f5$var$resetIDS();
        $ba66290d7469d0f5$var$calculateTotalFee();
        //if there are 3 or more addresses added - hide the add button
        $ba66290d7469d0f5$var$addButtonWrapper.toggleAttribute("hidden", document.querySelectorAll('div[data-name="address"]').length >= $ba66290d7469d0f5$var$addressWrapper.dataset.maxAllowedAddresses);
    });
}
//add action to all address removal buttons
function $ba66290d7469d0f5$var$addActionToRemoveButtons() {
    var _loop = function(i) {
        //
        if ((removeButton = addresses[i].querySelector('button[data-name="remove"]')) != null) {
            //
            if (removeButton.dataset.event == "true") return {
                v: void void 0
            };
            //
            removeButton.addEventListener("click", function(event) {
                //
                removeButton.setAttribute("event", "true");
                addresses[i].remove();
                $ba66290d7469d0f5$var$resetIDS();
                $ba66290d7469d0f5$var$calculateTotalFee();
                //if there are less than 3 addresses, show the add address button
                var addButtonWrapper = document.querySelector('[data-name="add-address-button-wrapper"]');
                addButtonWrapper.classList.toggle("hidden", document.querySelectorAll('div[data-name="address"]').length >= 3);
            });
        }
    };
    //
    var addresses = document.querySelectorAll('div[data-name="address"]');
    //
    for(var i = 0; i < addresses.length; i++){
        var _ret = _loop(i);
        if ((0, $h9OH6._)(_ret) === "object") return _ret.v;
    }
}
//change the ids for all input and label within each address div
function $ba66290d7469d0f5$var$resetIDS() {
    var _loop = function(i) {
        //
        addresses[i].querySelectorAll("input, label").forEach(function(item) {
            //
            if (item.tagName == "INPUT") {
                item.name = item.name.replace(/([0-9])$/, i);
                item.id = item.id.replace(/([0-9])$/, i);
            }
            //
            if (item.tagName == "LABEL") item.setAttribute("for", item.getAttribute("for").replace(/([0-9])$/, i));
        });
        //
        if ((addressCount = document.querySelector('form input[name="creditcheck_address_count"]')) != null) addressCount.setAttribute("value", addresses.length);
    };
    //
    var addresses = document.querySelectorAll('div[data-name="address"]');
    //
    if (!addresses) return;
    //
    for(var i = 0; i < addresses.length; i++)_loop(i);
}
function $ba66290d7469d0f5$var$calculateTotalFee() {
    //
    var addresses = document.querySelectorAll('div[data-name="address"]');
    //
    if (!addresses) return;
    //
    if ((creditcheckFee = document.querySelector('span[data-name="creditcheck-total-fee"]')) != null) creditcheckFee.innerText = 12 + (addresses.length - 1) * 1;
}

})();
//# sourceMappingURL=creditcheck.min.js.map
